var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{ref:"menuLink",staticClass:"text-sm"},[(_vm.menuItem.url)?_c('UiLink',{staticClass:"inline-flex",class:_vm.isParent
        ? 'mb-6 -tracking-[0.1px] text-gray-lighten2 opacity-50'
        : 'title uppercase tracking-[.12em] text-white',attrs:{"to":_vm.menuItem.url}},[_vm._v("\n    "+_vm._s(_vm.menuItem.name)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }